import { Platform, NavController, AlertController, LoadingController, ToastController, ModalController } from "@ionic/angular";
import { Component, OnInit, Renderer2 } from "@angular/core";
import { adjustViewZIndex } from "../../../globals";
import { TranslationService } from "../../../i18n/translation-service";
import { MessageDisplayUtil } from "../../../message-display-utils";
import { FeedbackCategory } from "../../../data/feedback-data";
import { FeedbackService } from "../../../providers/feedback-service/feedback-service";
import { Router } from "@angular/router";
import { Location } from "@angular/common";

@Component({
  templateUrl: 'feedback.page.html',
  styleUrls: ['feedback.page.scss'],
})
export class FeedbackPage implements OnInit {
  public categories: Array<FeedbackCategory> = [];
  public category: string;
  public subject: string;
  public message: string;

  constructor(private platform: Platform,
    private nav: NavController,
    private router: Router,
    private renderer: Renderer2,
    private alertCtl: AlertController,
    private loadingCtl: LoadingController,
    private toastCtl: ToastController,
    private translator: TranslationService,
    private modalCtrl:ModalController,
    private feedbackService: FeedbackService,
    private Location: Location) {
      this.modalCtrl.dismiss();
  }

  gotopage() {
    this.Location.back();
  }

  async ngOnInit() {
    let busy = await this.loadingCtl.create({
      message: "Loading categories..."
    });
    busy.present().then(() => {
      this.feedbackService.getCategories()
        .subscribe((categories: any) => {
          busy.dismiss().then(() => {
            this.categories = categories;
          });
        }), (error) => {
          busy.dismiss().then(() => {
            let msg = MessageDisplayUtil.getErrorMessage(error, "Error loading feedback categories");
            MessageDisplayUtil.showErrorToast(msg, this.platform, this.toastCtl, 5000, "bottom");
          });

        };
    })
  }

  ionViewDidEnter() {
    adjustViewZIndex(this.nav, this.renderer);
  }

  async submitFeedback() {
    let busy = await this.loadingCtl.create({
      message: "Submitting feedback..."
    });
    busy.present().then(() => {
      this.feedbackService.sendFeedbackFromPlayer(this.category,
        this.subject, this.message)
        .subscribe((id: number) => {
          busy.dismiss().then(async () => {
            let message = this.translator.translate("Feedback.FeedbackSuccessMessage");
            let title = this.translator.translate("Feedback.FeedbackSuccessTitle");
            let alert = await this.alertCtl.create({
              header: title,
              message: message,
              buttons: [{
                text: "OK",
                handler: () => {
                  alert.dismiss().then(() => {
                    this.category = "";
                    this.subject = "";
                    this.message = "";
                    this.Location.back();
                    // this.nav.pop();
                  })
                }
              }]
            });
            alert.present();
          });
        }, (error) => {
          busy.dismiss().then(() => {
            let msg = MessageDisplayUtil.getErrorMessage(error, "Error submitting your feedback. Try again later");
            MessageDisplayUtil.showErrorToast(msg, this.platform, this.toastCtl, 5000, "bottom");
          });
        });
    })

  }
}
